import styled from 'styled-components';

export const Panel = styled.div`
  background: var(--color-page);
  border: 1px solid var(--color-accent-subtle);
  border-radius: 12px;
  padding: 24px;
  margin-top: 12px;
`;
